module.exports = __webpack_public_path__ + "img/truidlogo.adf0366b.png";